export default{
    empty: 'No entries yet',
    noData: 'Add the first entry to track progress across appointments.',
    title: 'Notes per appointment',
    openAll: 'View all (open notes)'
}